import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { delay } from 'utils/Delay'
import { create } from 'utils/Object'

const bookAnimations = {
  spine: 'animations/spine/freespins/open-book/skeleton.json',
  animations: ['start', 'showsymb-idle', 'winsymb-idle'],
}

export class BookAnimation extends Spine{
  constructor(data) {
    super(create(data, bookAnimations))
    this._data = data
    this.spinModel = game.models.SpinModel.get()
    this.anim = bookAnimations.animations
    this.orientation = !!data.isRotationAnimation
    this.animAdd = ''
    this.createSignal()
  }

  createSignal() {
    super.createSignal()
    signal.on('ACTION:FS-START', this.animateBook.bind(this))
    signal.on('RESIZE', ({ orientation }) => {
      this.animAdd = orientation
    })
  }

  async animateBook() {
    const expendingSymbol = game.models.FreespinModel.get().expendingSymbol
    let symbols = this.spinModel.reelSymbols.filter((item) => item != this.spinModel.reelSymbols[0])
    symbols.push(expendingSymbol)
    this.stop()

    await start.call(this)
    await symbolChange.call(this)
    await win.call(this)

    async function start() {
      signal.dispatch('BOOK-START')
      if(this.orientation){
        await this.play(this.anim[0] + this.animAdd, true)
      }
      else {
        await this.play(this.anim[0], true)
      }

    }

    async function symbolChange() {
      const animation = this.orientation ? this.play(this.anim[1] + this.animAdd, true) : this.play(this.anim[1], true)
      return Promise.all([animation, loop()])
    }

    async function loop() {
      while (symbols.length) {
        const symbol = symbols.shift()
        signal.dispatch('SHOW:SYMBOL', symbol)
        await delay(.2)
      }
    }

    async function win() {
      signal.dispatch('BOOK-END')
      if(this.orientation){
        await this.play(this.anim[2] + this.animAdd, true)
      }
      else {
        await this.play(this.anim[2], true)
      }
    }
  }
}
